import firebase from "../../src/assets/config/firebase";

export const settings = async (userId, constants) => {
  try {
    const userData = await firebase.getSingleUser(userId);

    console.log("constants:", constants);

    if (userData && userData.specificSetting === true) {
      return {
        days: userData.workingDays || constants.days,
        totalHours: userData.productiveHours || constants.totalHours,
        late: userData.late || constants.late,
      };
    }

    return constants;
  } catch (err) {
    console.error("Error fetching user settings:", err);
    return constants; // fallback
  }
};



// WEBPACK FOOTER //
// ./src/utils/genralSpecificSettings.js